// extracted by mini-css-extract-plugin
export default {"cards":"Events_cards__tmIfP","message":"Events_message__aWILT"};